module.exports = __webpack_public_path__ + "img/assortment-category.d67c62d1.svg";